import { z } from "zod";
/**
 * Budget and capacity: request shapes and the response types both sides agree on.
 *
 * Money is integer minor units (cents) in an ISO 4217 currency. Hours are
 * minutes everywhere on the wire, like time entries.
 */
/** 40 hours, the default weekly capacity. */
export const DEFAULT_WEEKLY_CAPACITY_MINUTES = 40 * 60;
/** A person cannot be given more than the hours in a week. */
export const MAX_WEEKLY_CAPACITY_MINUTES = 168 * 60;
export const MAX_RATE_CENTS = 100_000_00;
export const MAX_BUDGET_MINUTES = 1_000_000 * 60;
export const MAX_BUDGET_CENTS = 100_000_000_000;
const currencyCode = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{3}$/, "Use a three-letter currency code.");
export const putProjectBudgetBody = z
    .object({
    budgetMinutes: z.number().int().min(0).max(MAX_BUDGET_MINUTES).nullable(),
    budgetCents: z.number().int().min(0).max(MAX_BUDGET_CENTS).nullable(),
    billableRateCents: z.number().int().min(0).max(MAX_RATE_CENTS).nullable(),
    currency: currencyCode.nullable(),
})
    .partial();
export const patchBudgetMemberBody = z
    .object({
    hourlyCostCents: z.number().int().min(0).max(MAX_RATE_CENTS).nullable(),
    weeklyCapacityMinutes: z.number().int().min(0).max(MAX_WEEKLY_CAPACITY_MINUTES),
})
    .partial();
//# sourceMappingURL=budget.js.map